import { Card, CardContent, Typography } from '@mui/material'
import React from 'react'

export const SimpleCardBlock = ({ children }) => {
    return (
        <Card mb={6}>
            <CardContent>
                <Typography variant='body1'>{children}</Typography>
            </CardContent>
        </Card>
    )
}
